// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","categoriesContainer":"_1_1Tckarkq6Em0e4fELryg","titleContainer":"_1OAsNJfESFU0nQcEFOMDP","errorMessage":"RpL01SPjYq6S_xBVpKSYf"};